import {LegacyPeriodReportBoundary} from "./Layout/LegacyPeriodReportBoundary.jsx";
import React, {useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import OrderOverviewCard from "./TablesAndGraphs/ByFilter/OrderOverviewCard.jsx";
import {FilterContext} from "../../../components/filters/DashboardFilterContextProvider.jsx";
import useDataFileDownloadState from "../../../api/utilities/useDataFileDownloadState.js";
import {ErpCalculationApi} from "../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../api/utilities/useAuthorityConfiguration.js";
import Spinner, {SpinnerSize} from "../../../components/Spinner.jsx";
import OrderPerformancePanel from "./TablesAndGraphs/ByFilter/OrderPerformancePanel.jsx";
import ChannelPerformancePanel from "./TablesAndGraphs/ByFilter/ChannelPerformancePanel.jsx";
import ProductPerformance from "./TablesAndGraphs/ByFilter/ProductPerformance.jsx";
import PnoPanel from "./TablesAndGraphs/ByFilter/PnoPanel.jsx";


function MainOrderOverviewContent({project}) {
    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <OrderDashboardLayout
        title={t('route.performance-summary')}
    >
        <OrderPerformancePanel project={project} />
        <PnoPanel project={project} />
        <ChannelPerformancePanel project={project} />
        <ProductPerformance project={project} />
    </OrderDashboardLayout>;
}

export default function MainOrderOverview(props) {
    return <LegacyPeriodReportBoundary project={props.project}><MainOrderOverviewContent {...props}/></LegacyPeriodReportBoundary>;
}
